module.exports = __webpack_public_path__ + "static/media/pannello.5c7f2272.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/battery/pannello.png
// module id = 479
// module chunks = 0